import _axios from '@/plugins/axios';
import { BillingsError } from '../../../lib/Errors';

export default {
	async getLogLevels () {
		const response = await _axios.get('system/loglevel');
		if (response.data.resFlag) {
			return response.data;
		}
		throw new BillingsError('Error getting log levels');
	},
	async setLogLevel (level) {
		const response = await _axios.post(`system/loglevel?level=${level}`);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new BillingsError('Error setting log level');
	},
};
